module.exports = __webpack_public_path__ + "static/media/cb1.02631220.jpg";